export function splitFullName(fullName: string): { firstName: string; lastName: string } {
    const trimmed = fullName.trim()
    const lastSpaceIndex = trimmed.lastIndexOf(' ')

    if (lastSpaceIndex === -1) {
        return { firstName: trimmed, lastName: '' }
    }

    return {
        firstName: trimmed.slice(0, lastSpaceIndex),
        lastName: trimmed.slice(lastSpaceIndex + 1),
    }
}
